import React,{useEffect} from 'react';

export function Checkout(props){

    // console.log(props);
    useEffect(() => {
        document.getElementById("redirectForm").submit();
    });
   
    return(
        <div> 
            {/* https://www.cashfree.com/checkout/post/submit
            https://test.cashfree.com/billpay/checkout/post/submit */}
            <form id="redirectForm" method="post" action="https://test.cashfree.com/billpay/checkout/post/submit">
                <input type="hidden" name="appId" value={props.location.state.paymentParam.appId}/>
                <input type="hidden" name="orderId" value={props.location.state.paymentParam.orderId}/>
                <input type="hidden" name="orderAmount" value={props.location.state.paymentParam.orderAmount}/>
                <input type="hidden" name="orderCurrency" value={props.location.state.paymentParam.orderCurrency}/>
                <input type="hidden" name="orderNote" value={props.location.state.paymentParam.orderNote}/>
                <input type="hidden" name="customerName" value={props.location.state.paymentParam.customerName}/>
                <input type="hidden" name="customerEmail" value={props.location.state.paymentParam.customerEmail}/>
                <input type="hidden" name="customerPhone" value={props.location.state.paymentParam.customerPhone}/>
                <input type="hidden" name="returnUrl" value={props.location.state.paymentParam.returnUrl}/>
                <input type="hidden" name="notifyUrl" value={props.location.state.paymentParam.notifyUrl}/>
                <input type="hidden" name="signature" value={props.location.state.signature}/>
            </form>
        </div>

    ); 
}
export default Checkout;
